import { useParams, useHistory } from "react-router-dom";
import { getReviewDetails,replayReview } from "../networking";
import { useState, useEffect } from "react";
import '../../../../../assets/css/providerreviews.css'
import { useDictionary } from "../../../../../utilities/hooks/UseDictionary";
import back from "../../../../../assets/icons/ic_caret_left.svg";
import ProfileImage from "../../../common/ProfileImage";
import useClientWidth from "../../../../../utilities/hooks/useClientWidth";
import { NavigatorPaths } from "../../../../../assets/dictionaries/NavigatorPaths";
import { DateFormatHelper } from "../../../../../utilities/helpers/DateFormatHelper";
import SimpleLoader from "../../../common/SimpleLoader";
import eye from '../../../../../assets/icons/ic_eye.svg';
import ExperienceDetailDialog from "../../resale_hub/components/ExperienceDetailDialog";
import useRatingPhrase from "../../../../../utilities/hooks/UseRatingPhrase";
import { ReactComponent as StarFillIcon } from '../../../../../assets/icons/ic_star.svg';
import { useAccount } from "../../../../../utilities/hooks/UseAccount";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as common from "../../../common/__redux/commonRedux";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomToast from '../../../common/CustomToast.js';
import ImageHelper from "../../../../../utilities/helpers/ImageHelper.js";
import placeholder from "../../../../../assets/images/bg_placeholder_square.svg";
import {ReactComponent as ReplyIcon} from "../../../../../assets/icons/ic_reply.svg";

const ProviderReviewDetail = ({ setErrorMessage,setWarningMessage }) => {
    const { id } = useParams();
    const history = useHistory();
    const account = useAccount();
    const dictionary = useDictionary();
    const [review, setReview] = useState(null);
    const [showLoader, setLoaderVisibility] = useState(true);
    const [opacity, setOpacity] = useState(0);
    const clientWidth = useClientWidth();
    const [selectedViewUrl, setSelectedViewUrl] = useState(null);
    const { getPhrase } = useRatingPhrase();
    const [reviewReplyValue, setReviewReplyValue] = useState('');
    const [tabIndex, setTabIndex] = useState(0);

    const handleReviewReplyChange = (event) => {
        setReviewReplyValue(event.target.value);
    };
    
    useEffect(() => {
        setTimeout(() => {
			setOpacity(1);
		}, 10);

        getDetailsByIdAsync();
    }, []);
    
    const dismiss = () => {
        history.goBack();
    };

    const getDetailsByIdAsync = async () => {
        setLoaderVisibility(true)
        try {
            let { data } = await getReviewDetails(id);
            setReview(data);

            setLoaderVisibility(false);
        } catch (e) {
            setLoaderVisibility(false);
            if (e.response) {
                setErrorMessage(e?.response?.data?.error_code.toString());
                setTimeout(() => {
                    setErrorMessage("");
                    dismiss();
                }, 2000);
            }
        }
    };
    const handleRedirect = (fromWhere) => {
        if(fromWhere == 'customer') {
            history.push(`/${NavigatorPaths.provider_customers.path}/${review.customer.id}`);
        } else if(fromWhere == 'booking') {
            history.push(`/${NavigatorPaths.bookings.path}/${review.booking.id}`);
        } else if(fromWhere == 'slot') {
            history.push(`/${NavigatorPaths.calendar.path}/${review.slot.id}?experience`);
        }
    }

	const handleCloseDetailDialog = () => {
		setSelectedViewUrl(null);
	};

    const postReview = async() =>{
        setLoaderVisibility(true);
        try {
            if(reviewReplyValue === '' || reviewReplyValue.trim().length === 0) {
                setLoaderVisibility(false);
                setWarningMessage('Reply field cannot be empty');
                return;
            }
            const response = await replayReview(review.id, {reply_text: reviewReplyValue});
            setReviewReplyValue('');
            toast.success(<CustomToast type='info' message={dictionary.reply_added_sucessfully} />, {
                position: 'top-right',
                autoClose: 5000,
                toastId: 'max-review-1',
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                closeButton: false,
                icon: false,
                className: 'toast-white-warning'
            });
            getDetailsByIdAsync();
        } catch (error) {
            setLoaderVisibility(false);
            if (error?.response?.data?.message) {
                toast.success(<CustomToast type='info' message={error?.response?.data?.message} />, {
                    position: 'top-right',
                    autoClose: 5000,
                    toastId: 'max-review-1',
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    closeButton: false,
                    icon: false,
                    className: 'toast-white-warning'
                });
            } else {
                toast.success(<CustomToast type='info' message={dictionary.customer_problem_deleting_booking} />, {
                    position: 'top-right',
                    autoClose: 5000,
                    toastId: 'max-review-1',
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    closeButton: false,
                    icon: false,
                    className: 'toast-white-warning'
                });
            }
        }
    }

    return (
        <div
            className="calendar-container review-details-container"
			style={{
				background: 'var(--background-color)',
				paddingTop: '0'
			}}
        >
            <div className="booking-details-wrapper" style={{ opacity: opacity }}>
                <div className={"booking-header-container booking-header-container-details"}>
                    <div className="booking-header-title">
						<div className="booking-detail-back-button" onClick={() => dismiss()}>
							<img src={back} />
						</div>
						<h2 style={{ marginLeft: "8px", fontWeight: 500 }} data-testid="booking-details-header">
							{dictionary.providerReview + " for " + (review?.experience?.title ?? "")}
						</h2>
					</div>
                </div>
                <div className="booking-details-body">
                    <div className="booking-details-container" style={{maxHeight: 'calc(100vh - 248px)'}}>
                        {review ? 
                        <>
                            <div className="settings-tab-bar">
                                <div
                                    onClick={() => setTabIndex(0)}
                                    className={tabIndex === 0 ? "settings-tab settings-tab-active" : "settings-tab"}
                                    data-testid="participants-and-addons-tab"
                                >
                                    {dictionary.Phrase}
                                </div>
                            </div>
                            <div className='detail-tab-container thin-scrollbar fade-on-load'>
                            <div className="d-flex justify-between">
                                <div
                                    className="settings-tab"
                                    style={{ color: 'var(--brand-dark-blue)', cursor: 'initial', fontSize:16, fontWeight:500,lineHeight:'24px', marginBottom:16}}
                                >
                                    {getPhrase(parseInt(review?.rating))}
                                </div>
                                <div className="d-flex">
                                    <div className="star-rating d-flex">
                                        <span className="review-rate">{parseFloat(review.rating).toFixed(1)}</span>
                                        <StarFillIcon width={12} height={12} style={{ color: '#22264C99',marginTop:1 }}/>
                                    </div>
                                </div>
                            </div>
                                <div className={`${review?.reply_text ? 'review_section review-with-reply' : 'review_section'}`}>
                                    <div className="d-flex justify-between">
                                        <div className="d-flex items-center" style={{gap: 12}}>
                                            <ProfileImage name={review.customer.name} photo={review?.customer.avatar} size={{width: 32, height: 32, fontSize: 13, lineHeight: 16}}/>
                                            <div>
                                                <h4 className="review_title truncate" title={review.customer.name}>{review.customer.name}</h4>
                                                <h4 className="review_date">{DateFormatHelper.monthYearTimeFormat(review.created_at)}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="review_descriptions" style={{marginTop: review.text ? 16 : 0}}>
                                        <h4 title={review.text}>{review.text}</h4>
                                    </div>
                                    {
                                        review.assets && review.assets.length > 0 ? (
                                            <div className="review_image_wrappper">
                                                {
                                                    review.assets?.map((image, index) => (
                                                        <img
                                                            key={index}
                                                            src={ImageHelper.getFullImageUrl(image.thumbnail_url)}
                                                            className="review-image"
                                                        />
                                                    ))
                                                }
                                            </div>
                                        ) : null
                                    }
                                </div>
                                {
                                    review?.reply_text ? (
                                        <div className="d-flex provider-replay-container">
                                            <ReplyIcon/>
                                            <div className="d-flex items-center" style={{gap: 12}}>
                                                <ProfileImage name={account.brand_name} photo={account?.company_photo?.path} size={{width: 32, height: 32, fontSize: 13, lineHeight: 16}}/>
                                                <div className="d-flex" style={{flexDirection:'column'}}>
                                                    <h4 className="review_title truncate" title={account.brand_name}>{account.brand_name}</h4>
                                                    <h4 className="review_date">{DateFormatHelper.monthYearTimeFormat(review.created_at)}</h4>
                                                </div>
                                            </div>
                                            <div className="review_descriptions" style={{marginTop: 16}}>
                                                <h4 title={review?.reply_text}>{review?.reply_text}</h4>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="booking-footer">
                                            <div className="booking-footer-textarea">
                                                <textarea placeholder="Add a reply" style={{resize:"none",marginTop:0}} rows="4" cols="50" maxLength='65000' onChange={handleReviewReplyChange} defaultValue={reviewReplyValue} />
                                            </div>
                                            <div className="review-post-button-container">
                                                <button
                                                    disabled={reviewReplyValue === ''}
                                                    onClick={reviewReplyValue !== '' ? postReview : null}
                                                    className={reviewReplyValue !== '' ? 'button' : 'button button-disabled'}
                                                >
                                                    {dictionary.reply}
                                                </button>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                            </>
                        : null }
                    </div>
                    {review ? (
                        <div className="booking-experience-details-container container-max-height">
                            <div
                                className="settings-tab-bar"
                                style={{
                                    justifyContent: 'space-between',
                                    backgroundColor: 'white',
                                    alignItems: 'center',
                                    borderTopLeftRadius: 12,
                                    borderTopRightRadius: 12
                                }}
                            >
                                <div
                                    className="settings-tab"
                                    style={{ color: 'var(--brand-dark-blue)', cursor: 'initial' }}
                                >
                                    {dictionary.details}
                                </div>
                            </div>
                            <div className="booking-experience-details-content-container thin-scrollbar">
                            {/* <div className="booking-experience-images-container">
                                <img
                                    className="experience-compact-thumb"
                                    onError={(e) => {
                                        e.currentTarget.src = placeholder;
                                    }}
                                    src={
                                        review.experience?.assets[0]
                                            ? ImageHelper.getFullImageUrl(
                                                review.experience?.assets[0]
                                            )
                                            : placeholder
                                    }
                                />
                                <img
                                    className="experience-compact-thumb"
                                    onError={(e) => {
                                        e.currentTarget.src = placeholder;
                                    }}
                                    src={
                                        review.experience?.assets[1]
                                            ? ImageHelper.getFullImageUrl(
                                                review.experience?.assets[1]
                                            )
                                            : placeholder
                                    }
                                />
                                <img
                                    className="experience-compact-thumb"
                                    onError={(e) => {
                                        e.currentTarget.src = placeholder;
                                    }}
                                    src={
                                        review.experience?.assets[2]
                                            ? ImageHelper.getFullImageUrl(
                                                review.experience?.assets[2]
                                            )
                                            : placeholder
                                    }
                                />
                                <div
                                    className="booking-experience-images-container-color"
                                    style={{ backgroundColor: review?.experience?.color }}
                                />
                            </div> */}
                                <div className="participant-row-container" style={{ justifyContent: 'space-between'}}>
                                    <h3 className='text-with-underline' onClick={() => setSelectedViewUrl(review.experience.view_url)} style={{ fontSize: '16px', marginTop: (clientWidth >= 767 ? '16px' : '8px'), marginBottom: '12px', cursor: 'pointer' }}>
                                        {review.experience.title}
                                    </h3>
                                    <img onClick={() => setSelectedViewUrl(review.experience.view_url)} src={eye} style={{ cursor: 'pointer' }}/>
                                </div>
                                <div className="participant-row-container"
                                    style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                                    {dictionary.date}
                                    </h4>
                                    <h4 style={{ fontWeight: 'normal' }} className={`${review.slot.id ? ' cursor-pointer text-with-underline' :''}`} onClick={review.slot?.id ? () => { handleRedirect('slot') } : null}>
                                        {DateFormatHelper.rangeDayMonthYearFormat(
                                            review.slot.start_time,
                                            review.slot.end_time
                                        )}
                                    </h4>
                                </div>
                                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                                        {dictionary.time}
                                    </h4>
                                    <h4 style={{ fontWeight: 'normal' }} className={`${review.slot.id ? ' cursor-pointer text-with-underline' :''}`} onClick={review.slot?.id ? () => { handleRedirect('slot') } : null}>
                                        {DateFormatHelper.timeRangeFormat(
                                            review.slot.start_time,
                                            review.slot.end_time
                                        )}
                                    </h4>
                                </div>
                                <div
                                    className="participant-row-container"
                                    style={{ justifyContent: 'space-between',marginTop: (clientWidth >= 767 ? '24px' : '16px') }}
                                >
                                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                                        {dictionary.customer}
                                    </h4>
                                    <div className="booking-customer-container" style={{gap: '8px'}}>
                                        <ProfileImage name={review.customer.name} photo={review.customer.avatar} size={{ width: 24, height: 24,fontSize: 11, lineHeight: 14 }}/>
                                        <h4 className={`truncate booking-customer-container-customername fw-400 font-family-roboto ${review.customer?.id ? ' cursor-pointer text-with-underline' :''}`} onClick={review.customer?.id ? () => { handleRedirect('customer') } : null} title={review.customer.name}>{review.customer.name}</h4>
                                    </div>
                                </div>
                                <div
                                    className="participant-row-container"
                                    style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}
                                >
                                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                                        {dictionary.booking}
                                    </h4>
                                    <div className="booking-customer-container" style={{gap: '8px'}}>
                                        <h4 className={`fw-400 font-family-roboto ${review.booking.id ? ' cursor-pointer text-with-underline' :''}`} onClick={review.booking?.id ? () => { handleRedirect('booking') } : null}># {review.booking.display_id}</h4>
                                    </div>
                                </div>
                                <div
                                    className="participant-row-container"
                                    style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}
                                >
                                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                                        {dictionary.create_date}
                                    </h4>
                                    <div className="booking-customer-container" style={{gap: '8px'}}>
                                        <h4 className={`fw-400 font-family-roboto`}>{DateFormatHelper.monthYearTimeFormat(review.created_at)}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    <ExperienceDetailDialog
                        viewUrl={selectedViewUrl}
                        showDialog={Boolean(selectedViewUrl)}
                        setShowDialog={handleCloseDetailDialog}
                    />
                    <SimpleLoader showLoader={showLoader} />
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}
ProviderReviewDetail.propTypes = {
	setErrorMessage: PropTypes.func.isRequired,
	setWarningMessage: PropTypes.func.isRequired,
};

export default connect(common.states, common.actions)(ProviderReviewDetail);